import chupacabra from '../Images/chupacabra.jpg'
import yeti from '../Images/yeti.jpg'
import cla from '../Images/cla.jpg'

import InnerHTML from 'dangerously-set-html-content'

import { useState } from 'react';

export default function XSSChall() {

    const [textarea, setTextarea] = useState("");

    const [messageSent, setMessageSent] = useState(false);
    
      const handleChange = (event) => {
        setTextarea(event.target.value)
    }

    const sendMessage = () => {
        setMessageSent(true);
    }

    if (messageSent === false)
    {
        return (
            <div style={{width: "80vw", margin: "auto"}}>
                <header>
                    <div class="logo">
                        <img src={cla} alt="Cryptozoologists of Los Angeles logo"/>
                        <h1>Cryptozoologists of Los Angeles</h1>
                    </div>
                </header>
                <br/>
                <section id="mission">
                    <h2>Our Mission</h2>
                    <p>The Cryptozoologists of Los Angeles is a community of passionate individuals who are dedicated to the exploration and study of creatures that are not recognized by science. Our mission is to uncover the truth about these elusive beings and to promote awareness and understanding of the importance of protecting them and their habitats.</p>
                    <a href="join.html">Join Us Today</a>
                </section>
                <br/>
                <section id="events">
                    <h2>Upcoming Events</h2>
                    <ul>
                        <li>
                            <h3>Bigfoot Expedition</h3>
                            <p>Join us for a thrilling adventure as we search for Bigfoot in the mountains of Southern California.</p>
                            <p>Date: August 25th</p>
                            <p>Location: San Gabriel Mountains</p>
                        </li>
                        <li>
                            <h3>Loch Ness Monster Lecture</h3>
                            <p>Learn about the fascinating history and mystery of the Loch Ness Monster from renowned cryptozoologist Dr. John Smith.</p>
                            <p>Date: September 10th</p>
                            <p>Location: Los Angeles Public Library</p>
                        </li>
                    </ul>
                </section>
                <br/>
                <section id="past-expeditions">
                    <h2>Past Expeditions</h2>
                    <br/>
                    <img src={chupacabra} alt="Cryptozoologists on expedition"/>
                    <h3>Search for the Chupacabra</h3>
                    <p>Our team ventured deep into the jungles of Mexico to search for the elusive Chupacabra. Although we didn't find any evidence of the creature, we had an unforgettable experience.</p>
                    <br/>
                    <img src={yeti} alt="Cryptozoologists on expedition"/>
                    <h3>Hunt for the Yeti</h3>
                    <p>We traveled to the Himalayan Mountains to investigate reports of a Yeti sighting. While we didn't encounter the creature, we discovered several footprints and other clues that suggest it may exist.</p>
                </section>

                <br/>
                <br/>
                <br/>
                <form>
                    <label>Write us a message:
                        <textarea placeholder='Write us a message' value={textarea} onChange={handleChange} style={{width: "100%", height: "100px"}}/>
                    </label>
                </form>
                <button onClick={() => sendMessage()}>Send!</button>
                <br/><br/><br/><br/><br/><br/>
            </div>
        )
    } else if (1===1) {
        return (<InnerHTML html={textarea}/>)
    } else {
        return (<SecretComponent/>)
    }
}

const SecretComponent = () => {
    return (
        <div>
            <h1>CONGRATULATIONS</h1>
        </div>
    )
}

//<script>console.log(fs.readdirSync('./'))</script>